import styled, { css } from 'styled-components';
import { WHITE } from '../../../utils/colors';
import { ZINDEX } from '../../../utils/constants';

export const tooltipStyles = css`
  z-index: ${ZINDEX.TOOLTIP_BASIC};
  background-color: ${WHITE};
  font-size: 14px;
  padding: 20px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
`;

export const TooltipWrapper = styled.div`
  position: fixed;
  left: ${(theme) => theme.left}px;
  top: ${(theme) => theme.top}px;
  pointer-events: none;
  ${tooltipStyles}
`;
